import { Injectable } from '@angular/core';
import { MobilePostMessage } from 'app/projects/shared/src/lib/models/mobile-post-message.model';

declare global {
    interface Window {
        webkit: any;
    }
}

interface MobileAppAndroid {
    postMessage(payload: string): any;
}

declare var MobileAppAndroid: MobileAppAndroid;

@Injectable({
    providedIn: 'root',
})
export class MobileAppService {
    constructor() {}

    sendPostMessage(message: MobilePostMessage): any {
        const payload = JSON.stringify(message);

        if (this._isAndroidBridgeAvailable()) {
            MobileAppAndroid.postMessage(payload);
        } else if (this._isIosBridgeAvailable()) {
            window.webkit.messageHandlers.MobileAppiOS.postMessage(payload);
        }
    }

    processByMobile(message: MobilePostMessage, extension: string): boolean {
        if (extension !== 'pdf') {
            return false;
        }

        const payload = JSON.stringify(message);

        if (this._isAndroidBridgeAvailable()) {
            MobileAppAndroid.postMessage(payload);
            return true;
        } else if (this._isIosBridgeAvailable()) {
            window.webkit.messageHandlers.MobileAppiOS.postMessage(payload);
            return true;
        } else {
            return false;
        }
    }

    private _isAndroidBridgeAvailable(): boolean {
        return typeof MobileAppAndroid !== 'undefined' && typeof MobileAppAndroid?.postMessage === 'function';
    }

    private _isIosBridgeAvailable(): boolean {
        return typeof window?.webkit?.messageHandlers?.MobileAppiOS?.postMessage === 'function';
    }
}
